<template>
  <a-select
    v-bind="$attrs"
    :value="value"
    :disabled="disabled || loading"
    :style="{ width: width + 'px', ...styleObj }"
    :placeholder="placeholder"
    :loading="loading"
    :allowClear = "allowClear"
    @change="onChange"
  >
    <a-select-option
      v-for="(item, index) in list"
      :key="index"
      :value="item[options.value || 'value']"
    >
      <span v-if="options.code">{{ item[options.code || "code"] }}-</span>
      {{ item[options.label || "label"] }}
    </a-select-option>
  </a-select>
</template>

<script>
import config from './config'
export default {
  name: 'GeneralSelect',
  props: {
    defaultValue: {
      type: [Number, String],
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    styleObj: {
      type: Object,
      default() {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 160
    },
    // 附加配置项
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    // 默认选中第一个
    defaultSelectFirst: {
      type: Boolean,
      default: true
    },
    allowClear: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    list() {
      let arr = []
      if (this.options.list) {
        arr = [...arr, ...this.options.list]
      }
      if (this.data) {
        arr = [...arr, ...this.data]
      }
      if (this.type) {
        arr = [...arr, ...this.config[this.type].list]
      }
      // 如果【value值为空】，【没有默认值】，且【列表不为空】，则默认选中第一个
      if (this.defaultSelectFirst && arr.length > 0 && this.isNull(this.value) && this.defaultValue === '') {
        this.onChange(arr[0][this.options.value || 'value'])
      }
      return arr
    }
  },
  data() {
    return {
      // 通过接口获取的数据
      config: config,
      data: [],
      loading: false
    }
  },
  methods: {
    isNull(v) {
      return v === undefined || v === null || v === '' || (typeof v === 'number' && isNaN(v))
    },
    onChange(e) {
      this.$emit('input', e)
      this.$emit('change', e)
    },
    async queryList() {
      if (this.options.queryList) {
        this.loading = true
        try {
          const res = await this.options.queryList()
          if (res.code === 0) {
            this.data = res.data
          }
        } catch (error) {
          console.log(error)
        }
        this.loading = false
      }
    }
  },
  created() {
    this.queryList()
  },
  mounted() {
    // 如果有【默认值】 选中默认值
    if (this.defaultValue !== '') {
      this.onChange(this.defaultValue)
    }
  }
}
</script>
